import { useGLTF } from '@react-three/drei'
import { useControls } from 'leva'

export default function HandSaw()
{
    const model = useGLTF('./models/tools/handsaw_wood/handsaw_wood_1k.gltf')
    model.scene.children[0].castShadow = true

    const leva = useControls('saw', {
        position:{ x:0.63, y:-1.02, z:0.27 },
        rotation:{ x:-0.04, y:-4, z:-1.57 }
    },
    { collapsed: true }
    )
    
    return <primitive
        object={model.scene}
        position={[leva.position.x,leva.position.y,leva.position.z]}
        rotation={[ leva.rotation.x,leva.rotation.y,leva.rotation.z ]}
    />
}